import React, { useEffect, useState } from 'react';
import './SplashLoader.css';

export default function SplashLoader({ onComplete }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const steps = [
      { target: 30,  delay: 80 },
      { target: 60,  delay: 120 },
      { target: 85,  delay: 60 },
      { target: 100, delay: 90 },
    ];

    let raf;

    function animate(step) {
      if (step >= steps.length) {
        setTimeout(() => onComplete?.(), 280);
        return;
      }
      const { target, delay } = steps[step];
      const tick = () => {
        setProgress((prev) => {
          if (prev >= target) {
            setTimeout(() => animate(step + 1), delay);
            return target;
          }
          raf = requestAnimationFrame(tick);
          return prev + 1;
        });
      };
      raf = requestAnimationFrame(tick);
    }

    animate(0);
    return () => cancelAnimationFrame(raf);
  }, [onComplete]);

  return (
    <div className="splash-loader" aria-label="Loading FITNDEX" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100}>
      <div className="splash-loader__logo">FITNDEX</div>
      <div className="splash-loader__bar-track">
        <div className="splash-loader__bar-fill" style={{ width: `${progress}%` }} />
      </div>
      <div className="splash-loader__percent">{progress}%</div>
    </div>
  );
}
